import Button from "../ui/Button";
import { ArrowLeft } from "lucide-react";
import { useAuthStore } from "../../store/authStore";

export default function AgentHeader({ navigate, className = "" }) {
  const { role } = useAuthStore();
  const isAdmin = role === "admin";

  if(!isAdmin){  
    return null;
  }

  return (
    <div className={`d-flex align-center mb-4 ${className}`}>
      <Button
        variant="outline"
        className="d-flex align-center gap-2"
        onClick={() => navigate(-1)}
      >
        <ArrowLeft size={18} />
        Back
      </Button>
    </div>
  );
}